import AssetsInstallationDetailMaterials from "./AssetsInstallationDetailMaterials";
export default AssetsInstallationDetailMaterials;
